
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M40.06 78.77h64.48v40.26H40.06zM112.72 129h16a4.72 4.72 0 004.72-4.73V75.66a4.72 4.72 0 00-4.72-4.73h-16.33a4.72 4.72 0 00-3.91 2.07l-3.11 4.56a4.72 4.72 0 00-.82 2.67v37.61a4.7 4.7 0 00.56 2.23l3.44 6.43a4.74 4.74 0 004.17 2.5z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M32.16 129H15.49a4.28 4.28 0 01-4.28-4.28V75.21a4.28 4.28 0 014.28-4.28h17A4.3 4.3 0 0136 72.8l3.32 4.88a4.23 4.23 0 01.74 2.41V118a4.29 4.29 0 01-.5 2l-3.63 6.77a4.27 4.27 0 01-3.77 2.23zM52.89 78.76v-9.49a4.41 4.41 0 014.41-4.4H88a4.4 4.4 0 014.42 4.4v9.49M66.77 30.18v-3.3A5.88 5.88 0 0172.65 21a5.94 5.94 0 015.88 5.88v3.3M78.53 43.36v21.06H66.77V43.36"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"33.6","y":"30.18","width":"78.09","height":"13.18","rx":"6.59"}})])
          )
        }
      }
    